export default function useClipboard() {
  return (text, toastFn) => {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(text)
        .then(() => {
          if (toastFn) toastFn('success', 'URL copied to clipboard');
        })
        .catch(() => {
          if (toastFn) toastFn('error', 'Failed to copy URL to clipboard');
        });
    } else {
      if (toastFn) toastFn('error', 'Clipboard API not supported');
    }
  };
} 